import React, {
  useCallback,
  useEffect,
  useRef,
} from 'react';
import './UiSize.css';

const SIZE_LIST = [
  { cl: 'ui-size-5', fontSize: '17px', label: 'Az' },
  { cl: 'ui-size-4', fontSize: '16px', label: 'Az' },
  { cl: 'ui-size-3', fontSize: '15px', label: 'Az' },
  { cl: 'ui-size-2', fontSize: '14px', label: 'Az' },
  { cl: 'ui-size-1', fontSize: '13px', label: 'Az' },
  { cl: 'ui-size-0', fontSize: '', label: 'Az' },
];

const UiSize = (props = { id: 0 }) => {
  const refs = useRef([]);
  const SIZE_KEY = `cb-size-${props.id}`;
  const ACTIVE_CLASS = 'active';

  const sizeSwitch = useCallback((className = '') => {
    const cl = document.body.classList;
    const list = refs.current;
    list.forEach(v => v.classList.remove(ACTIVE_CLASS));

    if (className) {
      cl.remove(...SIZE_LIST.map(v => v.cl));
      cl.add(className);
      localStorage.setItem(SIZE_KEY, className);

      const e = list.find(v => v.classList.contains(className));

      if (e) {
        e.classList.add(ACTIVE_CLASS);
      }

    } else {
      cl.remove(...SIZE_LIST.map(v => v.cl));
      localStorage.setItem(SIZE_KEY, '');
    }
  }, [SIZE_KEY]);

  const checkSize = useCallback(() => {
    const size = localStorage.getItem(SIZE_KEY);
    if (size && SIZE_LIST.map(v => v.cl).includes(size)) {
      sizeSwitch(size);
    }
  }, [sizeSwitch, SIZE_KEY]);

  useEffect(() => {
    checkSize();
  }, [checkSize]);

  return (
    <span className="btn-wrapper size-wrapper">
      <button className="btn btn-default" data-e2e-id="btn-ui-size"
        onClick={() => sizeSwitch()}>
        <i className={'fa fa-text-height'}/>
      </button>
      <ul className="size-list fade-in-up">
        {SIZE_LIST.map((v, i) => (
          <li key={i}
            data-e2e-id={`btn-${v.cl}`}
            ref={(ref) => ref && !refs.current.includes(ref) ? refs.current.push(ref) : null}
            style={{fontSize: v.fontSize}}
            className={v.cl}
            onClick={() => {
              sizeSwitch(v.cl);
            }}
          >{v.label}
          </li>
        ))}
      </ul>
    </span>
  );
};

export default UiSize;
